/* src/app/home-new/cancelling-uploads-modal/cancelling-uploads-modal.component.scss */
.inner-content {
  padding: 30px;
}
ion-button {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}
ion-icon {
  width: 24px;
  height: 24px;
}
ion-icon.title-icon {
  width: 30px;
  height: 30px;
}
.title {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 24px;
  font-weight: 500;
}
h3 {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 22px;
  font-weight: 500;
}
p {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 16px;
  font-weight: 400;
}
hr {
  margin-top: 30px;
  margin-bottom: 30px;
  border-top: 1px solid #cbcbcb;
}
.label {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}
/*# sourceMappingURL=cancelling-uploads-modal.component-2Z4J76SG.css.map */
